/**
 * Normalisation d'un nom de hashtag, alignée sur le trigger base de données :
 * trim, minuscules, « # » de tête retiré, accents retirés.
 * Les tirets et soulignés ne sont PAS fusionnés (tama-off, tama_off, tamaoff restent distincts).
 */
export const normalizeTagName = (raw: string): string =>
  raw
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase()
    .replace(/^#+/, "")
    .trim();
